import type { MessageCatalog } from '@mt/protocol';

/** Сообщения сервера (коды — packages/protocol/src/messages.ts). */
export const srv: MessageCatalog = {
  // ── соединение и сессия ──
  'err.rateLimited': 'zu viele Anfragen, bitte warten Sie',
  'err.badMessage': 'ungültige Nachricht',
  'err.internal': 'interner Serverfehler',
  'err.adminNoPlay': 'Administratoren nehmen nicht am Spiel teil',
  'err.authRequired': 'Anmeldung erforderlich',
  'err.adminRequired': 'Administrator-Anmeldung erforderlich',
  'err.adminOnly': 'nur für Administratoren verfügbar',
  'err.sessionExpired': 'Sitzung nicht gefunden oder abgelaufen — bitte melden Sie sich erneut an',
  'err.badData': 'ungültige Daten',
  'err.tooManyConnections': 'zu viele Verbindungen',
  // ── столы ──
  'err.roomNotFound': 'Tisch nicht gefunden',
  'err.unknownCategory': 'unbekannte Tischkategorie',
  'err.lowBalanceTable': 'nicht genug Credits für die Ante dieses Tisches',
  'err.lowBalance': 'nicht genug Credits für die Ante',
  'err.inOtherGame': 'Sie spielen gerade an einem anderen Tisch',
  'err.notSeated': 'Sie sitzen nicht an diesem Tisch',
  'err.notInGame': 'Sie nehmen nicht am aktuellen Spiel teil',
  'err.notParticipant': 'Sie nehmen nicht an diesem Spiel teil',
  'err.gameFinished': 'das Spiel ist beendet',
  'room.notStarted': 'Spiel nicht gestartet: {detail}',
  // ── учётная запись ──
  'err.banned': 'Konto gesperrt',
  'err.bannedReason': 'Konto gesperrt: {reason}',
  'err.accountNotFound': 'Konto nicht gefunden',
  'err.userNotFound': 'Benutzer nicht gefunden',
  'err.playerNotFound': 'Spieler nicht gefunden',
  'err.badReason': 'ungültiger Grund',
  'err.noBanBots': 'Bots werden nicht gesperrt',
  'err.botBalanceAuto': 'das Guthaben von Bots wird automatisch aufgefüllt',
  'err.botTopUpOnly': 'Aufladen ist nur für Bots möglich',
  'err.resetDuringGame': 'das Zurücksetzen des Guthabens ist während eines Spiels nicht möglich — warten Sie die Abrechnung ab',
  'err.nameShort': 'der Name muss mindestens 2 Zeichen lang sein',
  'err.nameChars': 'im Namen sind Buchstaben, Ziffern, Leerzeichen, Punkt, Bindestrich und Unterstrich erlaubt',
  'err.nameBot': 'der Name darf nicht den Eindruck eines Bots erwecken',
  'err.nameTaken': 'dieser Name ist bereits vergeben — bitte wählen Sie einen anderen',
  // ── вход и регистрация ──
  'err.loginFormat': 'Benutzername: 3–32 Zeichen — lateinische Buchstaben, Ziffern, Punkt, Bindestrich, Unterstrich; beginnt mit einem Buchstaben oder einer Ziffer',
  'err.loginTaken': 'dieser Benutzername ist vergeben',
  'err.registerRateLimited': 'zu viele Registrierungen von dieser Adresse, bitte versuchen Sie es später erneut',
  'err.loginRateLimited': 'zu viele Anmeldeversuche — bitte warten Sie einige Minuten',
  'err.loginInvalid': 'falscher Benutzername oder falsches Passwort',
  'err.registerFields': 'geben Sie Benutzername, Passwort und Namen ein',
  'err.loginFields': 'geben Sie Benutzername und Passwort ein',
  'err.passwordMissing': 'geben Sie ein neues Passwort ein',
  'err.passwordCurrentWrong': 'das aktuelle Passwort ist falsch',
  'err.passwordShort': 'das Passwort muss mindestens 8 Zeichen lang sein',
  'err.passwordLong': 'das Passwort ist zu lang (höchstens 128 Zeichen)',
  'err.passwordLetters': 'das Passwort muss Buchstaben und Ziffern enthalten',
  'err.sessionNotFound': 'Sitzung nicht gefunden — bitte melden Sie sich erneut an',
  'err.providerLinkedOther': 'dieses {provider}-Konto ist bereits mit einem anderen Spieler verknüpft',
  'err.providerOtherLinked': 'mit Ihrem Profil ist bereits ein anderes {provider}-Konto verknüpft',
  'err.providerNotLinked': 'dieser Anbieter ist nicht verknüpft',
  'err.providerLastMethod': 'die einzige Anmeldemethode kann nicht entfernt werden — legen Sie zuerst Benutzername und Passwort fest',
  'err.oauthNotConfigured': 'die Anmeldung über diesen Anbieter ist nicht eingerichtet',
  'err.oauthTooMany': 'zu viele unvollständige Anmeldungen, bitte versuchen Sie es später erneut',
  'err.oauthState': 'die Anmeldeanfrage ist veraltet oder gefälscht — bitte beginnen Sie die Anmeldung neu',
  'err.oauthProfile': 'der Anbieter hat beim Abruf des Profils {status} zurückgegeben',
  'err.oauthNoToken': 'der Anbieter hat kein Token ausgestellt',
  'err.oauthNoTokenDetail': 'der Anbieter hat kein Token ausgestellt: {detail}',
  'err.oauthNoSubject': 'der Anbieter hat keine Benutzerkennung übermittelt',
  'err.oauthCancelled': 'Anmeldung abgebrochen',
  'err.oauthProviderError': 'der Anbieter meldet einen Fehler: {detail}',
  'err.oauthIncomplete': 'unvollständige Antwort des Anbieters',
  'err.oauthFailed': 'Anmeldung über den Anbieter fehlgeschlagen — bitte versuchen Sie es später erneut',
  // ── история ──
  'err.gameNotFound': 'Spiel nicht gefunden',
  'err.replayParticipantsOnly': 'die Wiederholung ist nur für Teilnehmer des Spiels verfügbar',
  'err.packageNotFound': 'für dieses Spiel wurde kein Prüfpaket gefunden',
  'err.packageParticipantsOnly': 'das Paket ist nur für Teilnehmer des Spiels verfügbar',
  // ── ходы и прогноз ──
  'err.forecastLocked': 'die Prognose ist bereits fixiert',
  'err.betsLocked': 'die Einsätze sind bereits fixiert',
  'err.folded': 'Sie sind aus dem Spiel ausgestiegen',
  'err.directionRound3': 'in Runde 3 kann die Richtung nicht mehr geändert werden — nur die Anzahl der Punkte',
  'err.directionAllIn': 'nach einem All-in kann die Richtung nicht entfernt werden',
  'err.pointsInvalid': 'die Punktzahl muss positiv und ein Vielfaches des Preisticks sein',
  'err.pointsInvalidTick': 'die Punktzahl muss positiv und ein Vielfaches von {tick} sein',
  'err.pointsAllIn': 'nach einem All-in kann die Punktprognose nicht entfernt werden',
  'err.autoLimit': 'geben Sie ein Limit für den Auto-Call an',
  'err.noBetting': 'derzeit läuft keine Setzrunde',
  'err.notYourTurn': 'Sie sind nicht am Zug',
  'err.directionFirst': 'wählen Sie zuerst eine Richtung: höher oder tiefer',
  'err.allInPoints': 'geben Sie vor dem All-in eine vorläufige Punktzahl an',
  'err.checkToCall': 'Check nicht möglich: es gibt einen Einsatz zum Callen',
  'err.callNothing': 'nichts zu callen — verwenden Sie Check',
  'err.betExists': 'es wurde bereits gesetzt — verwenden Sie Call oder Raise',
  'err.betMin': 'Mindesteinsatz {amount|cr}',
  'err.creditsLow': 'nicht genug Credits',
  'err.raiseNoBet': 'kein Einsatz zum Erhöhen — verwenden Sie „Bet“',
  'err.raiseLimit': 'das Raise-Limit dieser Runde ist erreicht',
  'err.raiseMin': 'Raise mindestens auf {amount|cr}',
  'err.creditsNone': 'keine Credits verfügbar',
  'err.allInRaiseLimit': 'Raise-Limit erreicht — nur Call möglich',
  'err.actionUnknown': 'unbekannte Aktion',
  // ── причины отмены и завершения ──
  'reason.noAntes': 'keine Antes',
  'reason.allOut': 'alle Teilnehmer sind ausgeschieden',
  'reason.walkover': 'alle anderen Teilnehmer haben gefoldet',
  'reason.walkoverMulti': 'interner Fehler: Walkover bei mehreren Teilnehmern',
  'reason.flat': 'P₁ = P₀: weder „höher“ noch „tiefer“ ist eingetreten',
  'reason.noneCorrect': 'keiner der verbliebenen Spieler hat die Richtung erraten',
  'reason.noResult': 'kein verlässliches Ergebnis: {detail}',
  'reason.sourceDown': 'kein verlässliches Ergebnis: Datenquelle nicht erreichbar',
  'reason.serverStop': 'Server wird angehalten',
  // ── хронология розыгрыша ──
  'log.created': 'Spiel erstellt. Commitment: {commitment}…',
  'log.antes': 'Antes von je {ante|cr} in den Pot eingezahlt. P₀ = {p0}.',
  'log.round1': 'Runde 1: Indexchart und Wahl der Richtung. Preisskala verborgen.',
  'log.round2': 'Runde 2: Preisskala und Abstände in Punkten aufgedeckt.',
  'log.round3': 'Runde 3: Zusammensetzung des Index aufgedeckt — {composition}. Geben Sie die Punktzahl an.',
  'log.locked': 'Prognosen und Einsätze fixiert. Die Ziel-Minutenkerze bildet sich.',
  'log.uncalledReturn': '{name}: nicht gecallter Einsatz von {amount|cr} zurück',
  'log.autoFoldNoForecast': '{name}: automatischer Fold — keine vollständige Prognose bis zur Fixierung',
  'log.autoFoldTimeout': '{name}: automatischer Fold — Zugzeit abgelaufen',
  'log.roundClosed': 'Runde {round}: Einsätze abgeschlossen',
  'log.settled': 'Abrechnung abgeschlossen.',
  'log.cancelled': 'Spiel abgebrochen: {reason}. Antes zurückerstattet, keine Kommission einbehalten.',
};
